// src/components/shopping-action/shopping-action-provider.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingSheetFragment on EGDSSheet {\n    closeAnalytics {\n      linkName\n      referrerId\n    }\n    closeText\n    sheetType\n    sheetTypes {\n      sheetType\n      viewSize\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingOverlayFragment on ShoppingOverlayContainer {\n    overlayId\n    contentId\n    overlay {\n      __typename\n      ... on EGDSSheet {\n        ...ShoppingSheetFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingJoinListContainerFragment on ShoppingJoinListContainer {\n    actions {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      actionId\n      ... on ShoppingNavigateToOverlay {\n        overlayId\n      }\n      ... on ShoppingNavigateToURI {\n        resource {\n          value\n        }\n        target\n        useRelativePath\n      }\n      ... on ShoppingInvokeFunction {\n        paramsId\n        name\n        functionType\n      }\n    }\n    overlays {\n      ...ShoppingOverlayFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingActionButtonFragment on ShoppingButton {\n    accessibility\n    actionId\n    primary\n    buttonType\n    disabled\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React2 from "react";
// src/components/shopping-action/shopping-action-context.ts
import React from "react";
var ShoppingActionContext = React.createContext(null);
// src/components/shopping-action/shopping-action-provider.tsx
var ShoppingActionProvider = function(param) {
    var children = param.children, id = param.id, shoppingJoinListContainer = param.shoppingJoinListContainer, shoppingInvokeFunctionCallBack = param.shoppingInvokeFunctionCallBack;
    var shoppingActionContextData = React2.useMemo(function() {
        return {
            dialogId: "shopping-action-dialog-".concat(id),
            shoppingJoinListContainer: shoppingJoinListContainer,
            shoppingInvokeFunctionCallBack: shoppingInvokeFunctionCallBack
        };
    }, [
        id,
        shoppingJoinListContainer,
        shoppingInvokeFunctionCallBack
    ]);
    return /* @__PURE__ */ React2.createElement(ShoppingActionContext.Provider, {
        value: shoppingActionContextData
    }, children);
};
// src/components/shopping-action/shopping-action-hooks.ts
import React3 from "react";
import { useHistory } from "react-router-dom";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
import { liveAnnounce } from "uitk-react-utils";
// src/components/shopping-action/shopping-action-utils.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var SHOPPING_ACTION_LOG_EVENTS = {
    NO_ACTION_FOUND: new SystemEvent(SystemEventLevel.ERROR, "NO_ACTION_FOUND")
};
var _obj;
var UILinkTargetMap = (_obj = {}, _define_property(_obj, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj, "INTERNAL" /* INTERNAL */ , "_self"), _obj);
var getShoppingAction = function(actionId, actions) {
    var _actions_find;
    return (_actions_find = actions === null || actions === void 0 ? void 0 : actions.find(function(action) {
        return action.actionId === actionId;
    })) !== null && _actions_find !== void 0 ? _actions_find : null;
};
var getShoppingOverlayContainer = function(overlayId, overlays) {
    var overlayContainer = overlays === null || overlays === void 0 ? void 0 : overlays.find(function(item) {
        return item.overlayId === overlayId;
    });
    return overlayContainer !== null && overlayContainer !== void 0 ? overlayContainer : null;
};
// src/components/shopping-action/shopping-action-hooks.ts
var getErrorMessage = function(hookName) {
    return "".concat(hookName, " can only be used in a component inside <ShoppingActionProvider />");
};
var useShoppingAction = function(actionId) {
    var _shoppingActionContextData_shoppingJoinListContainer;
    var shoppingActionContextData = React3.useContext(ShoppingActionContext);
    if (!shoppingActionContextData) {
        throw new Error(getErrorMessage("useShoppingAction"));
    }
    return getShoppingAction(actionId, (_shoppingActionContextData_shoppingJoinListContainer = shoppingActionContextData.shoppingJoinListContainer) === null || _shoppingActionContextData_shoppingJoinListContainer === void 0 ? void 0 : _shoppingActionContextData_shoppingJoinListContainer.actions);
};
var useShoppingDialog = function(actionId) {
    var shoppingActionContextData = React3.useContext(ShoppingActionContext);
    if (!shoppingActionContextData) {
        throw new Error(getErrorMessage("useShoppingDialog"));
    }
    var dialogId = "".concat(shoppingActionContextData.dialogId, "-").concat(actionId);
    return useDialog(dialogId);
};
var useShoppingActionCallback = function(actionId) {
    var _shoppingActionContextData_shoppingJoinListContainer_actions, _shoppingActionContextData_shoppingJoinListContainer;
    var shoppingActionContextData = React3.useContext(ShoppingActionContext);
    if (!shoppingActionContextData) {
        throw new Error(getErrorMessage("useShoppingActionCallback"));
    }
    var dialogId = shoppingActionContextData.dialogId, shoppingJoinListContainer = shoppingActionContextData.shoppingJoinListContainer, shoppingInvokeFunctionCallBack = shoppingActionContextData.shoppingInvokeFunctionCallBack;
    var track = useClickTracker();
    var history = useHistory();
    var _useDialog = _sliced_to_array(useDialog("".concat(dialogId, "-").concat(actionId)), 2), dialogActions = _useDialog[1];
    var loggerEvents = useLoggerEvents(SHOPPING_ACTION_LOG_EVENTS);
    var shoppingActions = (_shoppingActionContextData_shoppingJoinListContainer = shoppingActionContextData.shoppingJoinListContainer) === null || _shoppingActionContextData_shoppingJoinListContainer === void 0 ? void 0 : (_shoppingActionContextData_shoppingJoinListContainer_actions = _shoppingActionContextData_shoppingJoinListContainer.actions) === null || _shoppingActionContextData_shoppingJoinListContainer_actions === void 0 ? void 0 : _shoppingActionContextData_shoppingJoinListContainer_actions.filter(function(item) {
        return item.actionId === actionId;
    });
    return React3.useCallback(function() {
        if ((shoppingActions === null || shoppingActions === void 0 ? void 0 : shoppingActions.length) === 0) {
            loggerEvents.NO_ACTION_FOUND.log({
                description: "No action was found in shoppingJoinListContainer.actions with actionId ".concat(actionId)
            });
            return;
        }
        shoppingActions === null || shoppingActions === void 0 ? void 0 : shoppingActions.forEach(function(shoppingAction) {
            if (shoppingAction.accessibility) {
                liveAnnounce(shoppingAction.accessibility);
            }
            switch(shoppingAction.__typename){
                case "ShoppingNavigateToOverlay":
                    dialogActions.toggleDialog();
                    track(shoppingAction.analytics.referrerId, shoppingAction.analytics.linkName);
                    break;
                case "ShoppingNavigateToURI":
                    track(shoppingAction.analytics.referrerId, shoppingAction.analytics.linkName);
                    if (shoppingAction.useRelativePath) {
                        history.push(shoppingAction.resource.value);
                    } else if (window && typeof window.open === "function") {
                        window.open(shoppingAction.resource.value, UILinkTargetMap[shoppingAction.target]);
                    }
                    break;
                case "ShoppingInvokeFunction":
                    {
                        var functionType = shoppingAction.functionType, name = shoppingAction.name, paramsId = shoppingAction.paramsId;
                        if (!shoppingInvokeFunctionCallBack || !paramsId) {
                            return;
                        }
                        track(shoppingAction.analytics.referrerId, shoppingAction.analytics.linkName);
                        shoppingInvokeFunctionCallBack(functionType, name, paramsId);
                        break;
                    }
                default:
                    break;
            }
        });
    }, [
        shoppingActions,
        loggerEvents.NO_ACTION_FOUND,
        actionId,
        dialogActions,
        track,
        history,
        shoppingInvokeFunctionCallBack
    ]);
};
var useShoppingOverlayContainer = function(actionId) {
    var _shoppingActionContextData_shoppingJoinListContainer;
    var shoppingActionContextData = React3.useContext(ShoppingActionContext);
    var shoppingAction = useShoppingAction(actionId);
    if (!shoppingAction || shoppingAction.__typename !== "ShoppingNavigateToOverlay") {
        return null;
    }
    return getShoppingOverlayContainer(shoppingAction.overlayId, shoppingActionContextData === null || shoppingActionContextData === void 0 ? void 0 : (_shoppingActionContextData_shoppingJoinListContainer = shoppingActionContextData.shoppingJoinListContainer) === null || _shoppingActionContextData_shoppingJoinListContainer === void 0 ? void 0 : _shoppingActionContextData_shoppingJoinListContainer.overlays);
};
// src/components/shopping-action/shopping-overlay.tsx
import React5 from "react";
import { gql as gql2 } from "@apollo/client";
// src/components/shopping-action/shopping-sheet.tsx
import React4 from "react";
import { gql } from "@apollo/client";
import { EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSSheet, EGDSSheetCloseButton, EGDSSheetTransition, UitkSheetTransition } from "@egds/react-core/sheet";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { Sheet } from "@egds/react-lodging";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var fragment = gql(_templateObject());
var _obj1;
var EGDSSheetTypeMap = (_obj1 = {}, _define_property(_obj1, "BOTTOM" /* BOTTOM */ , "bottom"), _define_property(_obj1, "SIDE" /* SIDE */ , "side"), _define_property(_obj1, "CENTERED" /* CENTERED */ , "centered"), _define_property(_obj1, "POPOVER" /* POPOVER */ , "popover"), _define_property(_obj1, "FULLSCREEN" /* FULLSCREEN */ , "full"), _obj1);
var ShoppingSheet = React4.forwardRef(function(param, triggerRef) {
    var actionId = param.actionId, data = param.data, sheetToolbar = param.sheetToolbar, children = param.children, tall = param.tall, _param_renderNavigateBar = param.renderNavigateBar, renderNavigateBar = _param_renderNavigateBar === void 0 ? true : _param_renderNavigateBar, _param_useToolbar = param.useToolbar, useToolbar = _param_useToolbar === void 0 ? true : _param_useToolbar, _param_openOnLoad = param.openOnLoad, openOnLoad = _param_openOnLoad === void 0 ? false : _param_openOnLoad;
    var track = useClickTracker2();
    var _useShoppingDialog = _sliced_to_array(useShoppingDialog(actionId), 3), isDialogOpen = _useShoppingDialog[0], dialogActions = _useShoppingDialog[1], DialogComponent = _useShoppingDialog[2];
    var _data_sheetType;
    var sheetType = (_data_sheetType = data.sheetType) !== null && _data_sheetType !== void 0 ? _data_sheetType : "CENTERED" /* CENTERED */ ;
    var sheetTypes = data.sheetTypes;
    React4.useEffect(function() {
        if (openOnLoad) {
            dialogActions.openDialog();
        }
    }, []);
    var closeDialog = React4.useCallback(function() {
        track(data.closeAnalytics.linkName, data.closeAnalytics.referrerId);
        dialogActions.closeDialog();
    }, [
        data,
        track,
        dialogActions
    ]);
    var _data_closeText;
    var closeText = (_data_closeText = data.closeText) !== null && _data_closeText !== void 0 ? _data_closeText : "close";
    var renderCloseButton = function() {
        return /* @__PURE__ */ React4.createElement(EGDSSheetCloseButton, null, /* @__PURE__ */ React4.createElement(EGDSTertiaryButton, {
            type: "button",
            onClick: closeDialog
        }, /* @__PURE__ */ React4.createElement(EGDSIcon, {
            name: "close",
            size: EGDSIconSize.MEDIUM,
            title: closeText
        })));
    };
    var renderNavigatebar = function() {
        if (renderNavigateBar) {
            var toolbarProps = {
                navigationContent: {
                    onClick: closeDialog,
                    navIconLabel: closeText
                },
                toolbarTitle: sheetToolbar === null || sheetToolbar === void 0 ? void 0 : sheetToolbar.title,
                toolbarSubtitle: sheetToolbar === null || sheetToolbar === void 0 ? void 0 : sheetToolbar.subtitle
            };
            return useToolbar ? /* @__PURE__ */ React4.createElement(EGDSToolbar, _object_spread({}, toolbarProps)) : renderCloseButton();
        }
        return null;
    };
    var commonEGDSSheetProps = React4.useMemo(function() {
        return {
            isVisible: isDialogOpen,
            type: EGDSSheetTypeMap[sheetType],
            triggerRef: triggerRef
        };
    }, [
        isDialogOpen,
        data,
        triggerRef,
        sheetType
    ]);
    var renderSideSheet = function(sideSheetLayout) {
        return /* @__PURE__ */ React4.createElement(EGDSSheetTransition, {
            isVisible: isDialogOpen
        }, /* @__PURE__ */ React4.createElement(EGDSSheet, _object_spread_props(_object_spread({}, commonEGDSSheetProps), {
            sideSheetLayout: sideSheetLayout
        }), renderNavigatebar(), children));
    };
    var bottomSheet = /* @__PURE__ */ React4.createElement(UitkSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React4.createElement(Sheet, _object_spread_props(_object_spread({}, commonEGDSSheetProps), {
        type: "bottom",
        tall: tall
    }), renderNavigatebar(), children));
    var centerSheet = /* @__PURE__ */ React4.createElement(DialogComponent, null, /* @__PURE__ */ React4.createElement(EGDSSheet, _object_spread_props(_object_spread({}, commonEGDSSheetProps), {
        centeredSheetSize: "small"
    }), renderNavigatebar(), children));
    var fullSheet = /* @__PURE__ */ React4.createElement(EGDSSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React4.createElement(DialogComponent, null, /* @__PURE__ */ React4.createElement(EGDSSheet, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, renderNavigatebar(), children)));
    if (sheetTypes) {
        var _sheetTypes_find, _sheetTypes_find1, _sheetTypes_find2;
        var _obj;
        var EGDSSheetTypeToComponentMap = (_obj = {}, _define_property(_obj, "BOTTOM" /* BOTTOM */ , bottomSheet), _define_property(_obj, "SIDE" /* SIDE */ , renderSideSheet({
            position: "trailing",
            columns: 6
        })), _define_property(_obj, "CENTERED" /* CENTERED */ , centerSheet), _define_property(_obj, "POPOVER" /* POPOVER */ , centerSheet), _define_property(_obj, "FULLSCREEN" /* FULLSCREEN */ , fullSheet), _obj);
        var smallViewSheetType = ((_sheetTypes_find = sheetTypes.find(function(sheetTypePerViewSize) {
            return sheetTypePerViewSize.viewSize === "SMALL" /* SMALL */ ;
        })) === null || _sheetTypes_find === void 0 ? void 0 : _sheetTypes_find.sheetType) || "CENTERED" /* CENTERED */ ;
        var mediumViewSheetType = ((_sheetTypes_find1 = sheetTypes.find(function(sheetTypePerViewSize) {
            return sheetTypePerViewSize.viewSize === "MEDIUM" /* MEDIUM */ ;
        })) === null || _sheetTypes_find1 === void 0 ? void 0 : _sheetTypes_find1.sheetType) || "CENTERED" /* CENTERED */ ;
        var largeViewSheetType = ((_sheetTypes_find2 = sheetTypes.find(function(sheetTypePerViewSize) {
            return sheetTypePerViewSize.viewSize === "LARGE" /* LARGE */ ;
        })) === null || _sheetTypes_find2 === void 0 ? void 0 : _sheetTypes_find2.sheetType) || "CENTERED" /* CENTERED */ ;
        return /* @__PURE__ */ React4.createElement(Viewport, null, /* @__PURE__ */ React4.createElement(ViewSmall, null, EGDSSheetTypeToComponentMap[smallViewSheetType]), /* @__PURE__ */ React4.createElement(ViewMedium, null, EGDSSheetTypeToComponentMap[mediumViewSheetType]), /* @__PURE__ */ React4.createElement(ViewLarge, null, EGDSSheetTypeToComponentMap[largeViewSheetType]));
    }
    if (sheetType === "SIDE" /* SIDE */ ) {
        return /* @__PURE__ */ React4.createElement(Viewport, null, /* @__PURE__ */ React4.createElement(ViewSmall, null, fullSheet), /* @__PURE__ */ React4.createElement(ViewMedium, null, renderSideSheet({
            position: "trailing",
            columns: 6
        })), /* @__PURE__ */ React4.createElement(ViewLarge, null, renderSideSheet({
            position: "trailing",
            columns: 4
        })));
    }
    if (sheetType === "CENTERED" /* CENTERED */ ) {
        return /* @__PURE__ */ React4.createElement(Viewport, null, /* @__PURE__ */ React4.createElement(ViewSmall, null, fullSheet), /* @__PURE__ */ React4.createElement(ViewMedium, null, centerSheet), /* @__PURE__ */ React4.createElement(ViewLarge, null, centerSheet));
    }
    if (data.sheetType === "FULLSCREEN" /* FULLSCREEN */ ) {
        return /* @__PURE__ */ React4.createElement(React4.Fragment, null, fullSheet);
    }
    return null;
});
ShoppingSheet.fragment = fragment;
ShoppingSheet.displayName = "ShoppingSheet";
// src/components/shopping-action/shopping-overlay.tsx
var fragment2 = gql2(_templateObject1(), ShoppingSheet.fragment);
var ShoppingOverlay = React5.forwardRef(function(param, triggerRef) {
    var data = param.data, actionId = param.actionId, renderNavigateBar = param.renderNavigateBar, sheetToolbar = param.sheetToolbar, children = param.children, useToolbar = param.useToolbar, tall = param.tall, openOnLoad = param.openOnLoad;
    var overlay = data.overlay;
    if (overlay.__typename === "EGDSSheet") {
        return /* @__PURE__ */ React5.createElement(ShoppingSheet, {
            data: overlay,
            ref: triggerRef,
            actionId: actionId,
            sheetToolbar: sheetToolbar,
            tall: tall,
            useToolbar: useToolbar,
            renderNavigateBar: renderNavigateBar,
            openOnLoad: openOnLoad
        }, children);
    }
    return null;
});
ShoppingOverlay.fragment = fragment2;
ShoppingOverlay.displayName = "ShoppingOverlay";
// src/components/shopping-action/shopping-overlay-mapper.tsx
import React6 from "react";
var ShoppingOverlayMapper = React6.forwardRef(function(param, triggerRef) {
    var actionId = param.actionId, sheetToolbar = param.sheetToolbar, children = param.children, renderNavigateBar = param.renderNavigateBar, tall = param.tall, useToolbar = param.useToolbar, openOnLoad = param.openOnLoad;
    var overlayContainer = useShoppingOverlayContainer(actionId);
    if (!overlayContainer) {
        return null;
    }
    return /* @__PURE__ */ React6.createElement(ShoppingOverlay, {
        data: overlayContainer,
        actionId: actionId,
        ref: triggerRef,
        sheetToolbar: sheetToolbar,
        tall: tall,
        useToolbar: useToolbar,
        renderNavigateBar: renderNavigateBar,
        openOnLoad: openOnLoad
    }, children);
});
ShoppingOverlayMapper.displayName = "ShoppingOverlayMapper";
// src/components/shopping-action/shopping-join-list-container-fragment.ts
import { gql as gql3 } from "@apollo/client";
var shoppingJoinListContainerFragment = gql3(_templateObject2(), ShoppingOverlay.fragment);
// src/components/shopping-action/shopping-action-button.tsx
import React7 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSPrimaryButton, EGDSSecondaryButton } from "@egds/react-core/button";
var fragment3 = gql4(_templateObject3());
var ShoppingActionButton = function(param) {
    var data = param.data, size = param.size, isFullWidth = param.isFullWidth;
    var accessibility = data.accessibility, actionId = data.actionId, primary = data.primary, buttonType = data.buttonType;
    var actionCallback = useShoppingActionCallback(actionId);
    var triggerRef = React7.useRef(null);
    var _obj;
    var buttonComponentMap = (_obj = {}, _define_property(_obj, "PRIMARY" /* PRIMARY */ , EGDSPrimaryButton), _define_property(_obj, "SECONDARY" /* SECONDARY */ , EGDSSecondaryButton), _obj);
    var ButtonComponent = buttonComponentMap[buttonType];
    if (buttonType === "PRIMARY" /* PRIMARY */  || buttonType === "SECONDARY" /* SECONDARY */ ) {
        return /* @__PURE__ */ React7.createElement(ButtonComponent, {
            "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : "",
            size: size,
            onClick: actionCallback,
            isFullWidth: isFullWidth,
            domRef: triggerRef
        }, primary);
    }
    return null;
};
ShoppingActionButton.fragment = fragment3;
ShoppingActionButton.displayName = "ShoppingActionButton";
export { EGDSSheetTypeMap, SHOPPING_ACTION_LOG_EVENTS, ShoppingActionButton, ShoppingActionProvider, ShoppingOverlay, ShoppingOverlayMapper, ShoppingSheet, UILinkTargetMap, getErrorMessage, getShoppingAction, getShoppingOverlayContainer, shoppingJoinListContainerFragment, useShoppingAction, useShoppingActionCallback, useShoppingDialog, useShoppingOverlayContainer }; /* istanbul ignore next -- @preserve */ 
//# sourceMappingURL=index.js.map